import './App.css';
import Sidebar from './Sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useCookies } from 'react-cookie';
import './Main.css';
import { FaCloudUploadAlt } from "react-icons/fa";
import Background from './Background';
import { useState, useCallback, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { ToastContainer, toast } from 'react-toastify';
import { useHistory, useParams } from 'react-router-dom';
import { getDisplayFields, FIELD_LABELS, FIELD_INPUT_TYPES } from './serviceFieldConfig';

const API_BASE = 'https://api.connecker.com/api';

function AddServiceItem() {
    const { serviceTypeId } = useParams();
    const history = useHistory();
    const [cookies] = useCookies(['user']);
    const [serviceType, setServiceType] = useState(null);
    const [formData, setFormData] = useState({});
    const [imageFile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const displayFields = getDisplayFields(serviceType?.allowed_fields);

    const setField = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const getServiceType = () => {
        var data = new FormData();
        data.append("service_type_id", serviceTypeId);
        fetch(`${API_BASE}/get_service_type`, {
            method: 'POST',
            body: data
        }).then(res => res.json()).then(data => {
            if (data.response_code === 200) {
                setServiceType(data.data);
            }
        });
    };

    useEffect(() => {
        getServiceType();
    }, [serviceTypeId]);

    const onDrop = useCallback(acceptedFiles => {
        if (acceptedFiles && acceptedFiles.length > 0) {
            const file = acceptedFiles[0];
            setImageFile(file);
            const reader = new FileReader();
            reader.onload = (e) => setImagePreview(e.target.result);
            reader.readAsDataURL(file);
        }
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: { 'image/*': ['.jpeg', '.jpg', '.png', '.gif', '.webp', '.svg'] },
        maxFiles: 1
    });

    const createServiceAPI = () => {
        const nameVal = formData.name;
        if (!nameVal || !String(nameVal).trim()) {
            toast.error("Please enter a name");
            return;
        }

        var data = new FormData();
        data.append("service_type_id", serviceTypeId);
        displayFields.forEach(field => {
            if (field === 'image') {
                if (imageFile) data.append("image", imageFile);
            } else {
                const val = formData[field];
                if (val !== undefined && val !== null && String(val).trim() !== '') {
                    data.append(field, String(val).trim());
                }
            }
        });

        setIsLoading(true);
        fetch(`${API_BASE}/create_service`, {
            method: 'POST',
            body: data,
            headers: { 'Authorization': `Bearer ${cookies.token}` }
        }).then(res => res.json()).then(data => {
            setIsLoading(false);
            if (data.response_code === 200) {
                toast.success(data.message);
                setTimeout(() => history.push(`/service_list/${serviceTypeId}`), 1000);
            } else {
                toast.error(data.message || 'Failed to create service');
            }
        }).catch(() => {
            setIsLoading(false);
            toast.error('Failed to create service');
        });
    };

    return (
        <div className="content">
            <div className="row d-flex justify-content-center">
                <div className="col-2 col-sm-2">
                    <Sidebar />
                </div>
                <div className="col-10 col-sm-10" style={{ paddingLeft: "40px" }}>
                    <Background />
                    <div className="mb-2">
                        <button
                            className="btn btn-link text-white p-0"
                            onClick={() => history.push(`/service_list/${serviceTypeId}`)}
                            style={{ textDecoration: 'none', fontSize: '14px' }}
                        >
                            ← Back to {serviceType ? serviceType.name : 'Services'}
                        </button>
                    </div>
                    <h4 style={{ color: "white", marginTop: "10px" }}>
                        Add Service {serviceType ? `(${serviceType.name})` : ''}
                    </h4>
                    <div className="card" style={{ width: "100%" }}>
                        <div className="card-body">
                            <div className="d-flex">
                                <h6 style={{ color: "orange" }}>Basic</h6>
                                &nbsp;
                                <h6>Information</h6>
                            </div>
                            <br />

                            {displayFields.map(field => {
                                if (field === 'image') {
                                    return (
                                        <div key={field} className="mb-3">
                                            <label className="form-label" style={{ fontWeight: "500" }}>{FIELD_LABELS[field]} (optional)</label>
                                            {imagePreview && (
                                                <div className="mb-2">
                                                    <img
                                                        src={imagePreview}
                                                        alt="Preview"
                                                        style={{
                                                            width: "200px",
                                                            height: "120px",
                                                            objectFit: "cover",
                                                            borderRadius: "8px",
                                                            border: "1px solid #ddd"
                                                        }}
                                                    />
                                                </div>
                                            )}
                                            <div {...getRootProps()} className="container" style={{ borderRadius: "16px", height: "12rem", backgroundColor: "#FCC981", cursor: "pointer", maxWidth: "25rem" }}>
                                                <input {...getInputProps()} />
                                                {!isDragActive ? (
                                                    <center>
                                                        <FaCloudUploadAlt style={{ width: "5rem", height: "5rem", color: "#FF4500" }} />
                                                        <br /><br />
                                                        <h5><b>Drop Files Or Click To Upload</b></h5>
                                                    </center>
                                                ) : null}
                                            </div>
                                        </div>
                                    );
                                }
                                const inputType = FIELD_INPUT_TYPES[field] || 'text';
                                const isRequired = field === 'name';
                                return (
                                    <div key={field} className="mb-3">
                                        <label className="form-label" style={{ fontWeight: "500" }}>{FIELD_LABELS[field] || field}{isRequired ? ' *' : ''}</label>
                                        {inputType === 'textarea' ? (
                                            <textarea
                                                className="form-control"
                                                rows={3}
                                                style={{ border: "1px solid lightgrey", borderRadius: "25px", padding: "10px", maxWidth: "25rem" }}
                                                placeholder={FIELD_LABELS[field] || field}
                                                value={formData[field] ?? ''}
                                                onChange={(e) => setField(field, e.target.value)}
                                                required={isRequired}
                                            />
                                        ) : (
                                            <input
                                                type={inputType}
                                                className="form-control"
                                                style={{ border: "1px solid lightgrey", borderRadius: "25px", padding: "10px", maxWidth: "25rem" }}
                                                placeholder={FIELD_LABELS[field] || field}
                                                value={formData[field] ?? ''}
                                                onChange={(e) => setField(field, e.target.value)}
                                                required={isRequired}
                                            />
                                        )}
                                    </div>
                                );
                            })}

                            <br />
                            <button
                                onClick={createServiceAPI}
                                disabled={isLoading}
                                style={{
                                    color: "white",
                                    backgroundColor: "#FF4500",
                                    border: "1px solid #FF4500",
                                    borderRadius: "25px",
                                    padding: "10px 40px",
                                    margin: "5px",
                                    opacity: isLoading ? 0.6 : 1,
                                    cursor: isLoading ? "not-allowed" : "pointer"
                                }}
                            >
                                {isLoading ? 'Submitting...' : 'Submit'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
}

export default AddServiceItem;
